import { VFC } from 'hoist-non-react-statics/node_modules/@types/react'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { Button, ButtonsDiv, CancelButton, Layout } from './styles'

const MessageDelete: VFC<ModalProps<{ execDelete: () => Promise<any> }>> = ({
  execDelete,
  close,
}) => (
  <Layout>
    <h3>メッセージの送信を取り消しますか？</h3>
    <p>送信取り消しを行ったメッセージは、相手のルームでも表示されません。</p>
    <ButtonsDiv>
      <CancelButton onClick={close}>キャンセル</CancelButton>
      <Button
        onClick={async () => {
          await execDelete()
          close()
        }}
      >
        送信取消
      </Button>
    </ButtonsDiv>
  </Layout>
)

export const MessageDeleteModal = asModal(MessageDelete)
